<script>
  export default {
    props: ['visit', 'disclaimer', 'menu', 'social'],

    methods: {
      className (icon) {
        return 'fa-' + icon
      }
    }
  }
</script>

<template>
  <footer class="footer">
    <div class="container">
      <div class="square">
        <div class="wrap">
          <div class="social">
            <a v-for="icon in social" class="icon is-large" :key="icon.icon" :href="icon.url">
              <i class="fa fa-3x" :class="className(icon.icon)"></i>
            </a>
          </div>
          <p>{{ visit }}</p>
          <p class="links">
            <a v-for="link in menu" :key="link.title" :href="link.url">{{ link.title }}</a>
          </p>
        </div>
      </div>
    </div>
    <div class="cc"><span>{{ disclaimer }}</span></div>
  </footer>
</template>

<style lang="scss" scoped>
  @import "../sass/variables";

  .footer {
    background: url('../assets/footer.svg');
    height: 357px;
    padding: 0;
    position: relative;
    background-size: 1084px 357px;
  }

  .cc {
    color: white;
    font-size: 0.75rem;

    @include touch {
      background: url('../assets/cc.svg');
      background-size: cover;
      text-align: center;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;

      > span {
        width: 320px;
      }
    }

    @include desktop {
      position: absolute;
      width: 140px;
      left: 16px;
      bottom: 16px;
    }
  }

  .social {
    margin-bottom: 35px;
  }

  .social a:not(:first-child) {
    margin-left: 10px;
  }

  .square {
    background: #26302F;
    text-align: right;
    margin-left: auto;

    width: 50%;
    min-width: 280px;
    max-width: 330px;
    margin-right: 20px;

    @include aspect-ratio(1, 1);
  }

  .square .wrap {
    padding: 32px 47px;
  }

  .square, .square a {
    color: white;
  }

  .links {
    margin-top: 2em;
  }

  .links a:not(:first-child) {
    margin-left: 4em;
  }
</style>



// WEBPACK FOOTER //
// partials/CreateFooter.vue